export default (state = {}, action) => {
  switch (action.type) {
    case 'PANEL_PROMOTIONS_GET':
      return { ...state, promotions: action.promotions };
    default:
      return state;
  }
};
